/**
 * Function that returns an array of objects without the property passed as second parameter
 * @param {Array} arr
 * @param {String} propToRemove
 */
const removePropertyfromArrOfObjs = (arr, propToRemove) =>
  arr.map(({ [propToRemove]: _, ...rest }) => rest);

export default removePropertyfromArrOfObjs;
